import React, { useEffect } from 'react'
import { useFilterStore } from '../../state/filterStore'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { BrewOption } from 'src/types/schema/graphql'
import { parseLabel } from '../../utils/functions'

const BrewOptions: React.FC = () => {
    const {
        brewFilterOptions,
        setBrewFilterOptions,
        toggleBrewArrowUp,
        setToggleBrewArrowUp,
        setFilterCount,
        showAllFilters,
        setShowAllFilters,
    } = useFilterStore()

    // Use effect to update UI whenever a user clicks on the homepage option for a preset filter
    useEffect(() => {
        setFilterCount()
    }, [brewFilterOptions])

    const parseIconBrewOptions = (item: string) => {
        if (item === 'Gluten_Free') {
            return 'GlutenFree'
        } else if (item === 'Non__Alcoholic') {
            return 'NonAlcoholic'
        } else {
            return item
        }
    }

    const handleFilterSelection = (item: BrewOption) => {
        if (brewFilterOptions?.length) {
            if (!brewFilterOptions?.includes(item)) {
                setBrewFilterOptions([...brewFilterOptions, item])
            } else {
                setBrewFilterOptions(brewFilterOptions?.filter((brew) => brew !== item))
            }
        } else {
            setBrewFilterOptions([item])
        }
    }
    const orderedBrewOptions = [
        BrewOption.Beer,
        BrewOption.Kombucha,
        BrewOption.GlutenFree,
        BrewOption.Seltzer,
        BrewOption.Cider,
        BrewOption.Wine,
        BrewOption.Coffee,
        BrewOption.Cocktails,
        BrewOption.NonAlcoholic,
    ]

    const brewOptionChoices = orderedBrewOptions.map((item) => ({
        label: parseLabel(item),
        value: item,
    }))

    return (
        <div
            className={classNames(
                'flex flex-col items-start justify-start',
                toggleBrewArrowUp ? 'mb-2' : ''
            )}
        >
            <UI.Button
                label='Brews'
                data-cy='filterBrews'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pl-0 pb-0'
                onClick={() => setToggleBrewArrowUp(!toggleBrewArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleBrewArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>
            {brewFilterOptions?.length && toggleBrewArrowUp ? (
                <div className='flex w-full flex-col'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-0 text-sm flex items-center font-thin '
                        size='sm'
                        onClick={() => {
                            setBrewFilterOptions([])
                            setFilterCount()
                        }}
                    >
                        <UI.Icon
                            slug='HeroIconsSolid.XCircle'
                            theme='link'
                            customClasses='mr-2'
                            size='sm'
                        />
                        Clear
                    </UI.Button>
                </div>
            ) : (
                ''
            )}
            <div
                className={classNames(
                    !toggleBrewArrowUp ? 'hidden' : '',
                    'grid w-full grid-cols-2 flex-wrap gap-2 overflow-hidden pl-1 pt-2',
                    showAllFilters?.brewOptions ? 'h-auto' : 'max-h-44'
                )}
            >
                {brewOptionChoices.map((item, index) => (
                    <div
                        key={`filterOption-${item?.value}`}
                        className='flex min-h-20 flex-col overflow-hidden'
                    >
                        <UI.Button
                            theme='link'
                            id={`filterBrew-${item?.value}-${index}`}
                            customClasses={classNames(
                                'p-3 brew-filter border-r-1  flex flex-col h-auto',
                                brewFilterOptions?.includes(item?.value)
                                    ? 'border-dark bg-gray-50'
                                    : 'border-gray-100'
                            )}
                            onClick={() => handleFilterSelection(item?.value)}
                        >
                            <UI.Icon
                                slug={parseIconBrewOptions(item?.value)}
                                size='md'
                                customClasses='mb-2'
                            />
                            <p className='text-sm font-normal text-dark'>{item?.label}</p>
                        </UI.Button>
                    </div>
                ))}
            </div>
            {toggleBrewArrowUp && (
                <div className='flex w-full flex-col'>
                    <UI.Button
                        theme='link'
                        customClasses='pl-1 text-sm flex items-center font-thin'
                        size='sm'
                        onClick={() =>
                            setShowAllFilters({
                                ...showAllFilters,
                                brewOptions: !showAllFilters.brewOptions,
                            })
                        }
                    >
                        {showAllFilters?.brewOptions ? 'Show Less' : 'Show More'}
                        <UI.Icon
                            slug='HeroIconsSolid.ChevronDown'
                            theme='link'
                            customClasses={classNames(
                                'ml-2 text-gray-300',
                                showAllFilters?.brewOptions ? '-rotate-180' : ''
                            )}
                            size='sm'
                        />
                    </UI.Button>
                </div>
            )}
        </div>
    )
}

export default React.memo(BrewOptions)
